// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSPanel/index.less
// module id = 681
// module chunks = 42